import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=68c25950&scoped=true&lang=pug&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "./Base.scss?vue&type=style&index=0&id=68c25950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c25950",
  null
  
)

export default component.exports